import { Tag, TagProps } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { IoClose } from 'react-icons/io5';

export function CategoryTag({ active, children, ...props }: { active: boolean } & PropsWithChildren & TagProps) {
  return (
    <Tag
      minW={'auto'}
      whiteSpace={'nowrap'}
      textAlign={'center'}
      backgroundColor={'transparent'}
      borderWidth={'1px'}
      borderColor={active ? 'primaryColor' : 'blackAlpha.700'}
      padding="10px 15px"
      cursor={'pointer'}
      fontSize={'16px'}
      fontWeight={500}
      transition={'0.5s'}
      textTransform={'capitalize'}
      color={active ? 'primaryColor' : 'blackAlpha.700'}
      {...props}
    >
      {children}
      {active && <IoClose style={{ marginLeft: '5px' }} size={'18px'} />}
    </Tag>
  );
}
